import { valid } from "semver";

import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

export function getIosAppVersion() {
  if (!isNativeAppiOS()) return null;

  const regEx = /appVersion:([^\s]+)/g;
  const matches = navigator.userAgent.match(regEx);

  if (!matches) return null;

  const appVersion = matches[0].split(":")[1];

  return valid(appVersion);
}
